import { TableColumnModel } from '../../../Forms/models/table-column.model';
import { styleNameColumnConfig } from './style-name-column.config';
import { selectColumnConfig } from '../../../Forms/config/table/select-column.config';
import { styleTypeColumnConfig } from './style-type-column.config';

export const styleColumnsConfig: TableColumnModel[] = [
    styleNameColumnConfig,
    styleTypeColumnConfig
];
